import { z } from 'zod';

export const poLineSchema = z.object({
  lineId: z.string(),
  itemId: z.string(),
  itemName: z.string(),
  sku: z.string(),
  quantity: z.number(),
  unit: z.string(),
  unitPrice: z.number(),
  totalPrice: z.number(),
  receivedQuantity: z.number().optional(),
});

export const purchaseOrderSchema = z.object({
  poId: z.string(),
  poNumber: z.string(),
  supplierId: z.string(),
  supplierName: z.string(),
  status: z.enum(['draft', 'pending', 'approved', 'sent', 'acknowledged', 'shipped', 'delivered', 'cancelled']),
  deliveryZone: z.string(),
  deliverySiteId: z.string(),
  deliverySiteName: z.string(),
  expectedDeliveryDate: z.string(),
  actualDeliveryDate: z.string().optional(),
  lines: z.array(poLineSchema),
  subtotal: z.number(),
  tax: z.number(),
  total: z.number(),
  currency: z.string(),
  notes: z.string().optional(),
  createdBy: z.string(),
  createdByName: z.string(),
  approvedBy: z.string().optional(),
  approvedByName: z.string().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type PurchaseOrder = z.infer<typeof purchaseOrderSchema>;
export type POStatus = PurchaseOrder['status'];

export const purchaseOrdersResponseSchema = z.object({
  data: z.array(purchaseOrderSchema),
  pagination: z.object({
    nextToken: z.string().nullable(),
    totalCount: z.number() 
  }),
});

export type PurchaseOrdersResponse = z.infer<typeof purchaseOrdersResponseSchema>;

export const PO_STATUS_LABELS: Record<POStatus, string> = {
  draft: 'Draft',
  pending: 'Pending',
  approved: 'Approved',
  sent: 'Sent',
  acknowledged: 'Acknowledged',
  shipped: 'Shipped',
  delivered: 'Delivered',
  cancelled: 'Cancelled',
};

export const PO_STATUS_COLORS: Record<POStatus, string> = {
  draft: 'bg-gray-100 text-gray-800',
  pending: 'bg-amber-100 text-amber-800',
  approved: 'bg-blue-100 text-blue-800',
  sent: 'bg-indigo-100 text-indigo-800',
  acknowledged: 'bg-cyan-100 text-cyan-800',
  shipped: 'bg-purple-100 text-purple-800',
  delivered: 'bg-green-100 text-green-800',
  cancelled: 'bg-red-100 text-red-800',
};
